import React from 'react';
import { IntlProvider } from 'react-intl';
import LocaleContext from '../../localeContext';
import useExtractTranslations from '../../useExtractTranslations';

const defaultLocale = {
  lang: 'en',
  path: 'en',
  label: 'English',
  default: true,
};

function IntlWrapper({ children, locale = defaultLocale }) {
  return (
    <LocaleContext.Provider value={{ locale }}>
      <IntlProviderWithContext locale={locale}>
        {children}
      </IntlProviderWithContext>
    </LocaleContext.Provider>
  );
}

function IntlProviderWithContext({ children, locale }) {
  const messages = useExtractTranslations();

  return (
    <IntlProvider locale={locale.lang} messages={messages}>
      {children}
    </IntlProvider>
  );
}

export default IntlWrapper;
